var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 105,
    viewBox: "0 0 350 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_1942)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 105,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2704_1942)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2704_1942)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 118,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.649 87.9333C292.005 100.812 143.176 118.843 1.01351 87.9333L0 87.5469V-33H1.01351H350V87.1605L348.649 87.9333Z",
    fill: "#0099FF",
    stroke: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.05 10.9042C146.92 12.0342 146.041 13.3525 145.434 14.7545C144.032 17.977 144.032 21.7017 145.602 24.9033C147.192 28.1467 150.205 30.4695 153.7 31.3065C154.683 31.5367 155.73 31.6622 156.776 31.6413C159.14 17.977 148.05 10.9042 148.05 10.9042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.535 -2.8647C214.3 -19.9399 175.169 -25.5688 156.86 -15.2526C151.775 -12.3858 148.301 -8.28439 147.694 -2.8647C144.869 22.0994 161.4 44.95 180.38 44.95C187.264 44.95 195.342 42.3133 202.038 36.4751C210.617 29.0048 216.916 16.2821 215.535 -2.8647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.941 22.8317C146.794 22.9154 143.488 24.715 140.914 28.921C138.55 32.7713 136.353 39.4884 139.345 49.4907L141.103 48.9676C138.864 41.4972 139.303 35.1149 142.421 29.9673C144.744 26.1379 147.778 24.4639 147.799 24.443L146.941 22.8317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.914 47.0634C143.283 47.0634 145.204 48.984 145.204 51.3531C145.204 53.7223 143.283 55.6428 140.914 55.6428C138.545 55.6428 136.625 53.7223 136.625 51.3531C136.625 48.984 138.545 47.0634 140.914 47.0634Z",
    fill: "#294F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.364 12.2226C205.364 8.79083 201.598 6.69829 196.764 5.44276C191.658 4.12446 185.36 3.74779 180.965 3.78964C174.667 3.85242 162.551 4.94055 158.178 8.91638C157.152 9.85803 156.545 10.9461 156.545 12.2226C156.545 15.9264 158.094 19.2954 160.584 21.7228C163.074 24.1501 166.548 25.6567 170.356 25.6567H191.554C195.99 25.6567 199.945 23.627 202.456 20.4672C204.297 18.1864 205.364 15.3196 205.364 12.2226Z",
    fill: "#294F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.365 12.2224C205.365 8.79064 201.598 6.6981 196.764 5.44257C191.658 4.12427 185.36 3.74761 180.966 3.78946C174.667 3.85224 162.551 4.94037 158.178 8.9162C170.628 9.29286 191.805 11.3435 202.477 20.467C204.297 18.1862 205.365 15.3194 205.365 12.2224Z",
    fill: "#252525",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.492 28.1468C159.496 26.8076 165.732 29.6116 169.896 32.6876C173.893 35.6381 177.994 40.2836 177.073 41.6019C176.278 42.7737 171.675 41.0997 168.787 39.5721C162.342 36.1194 157.404 29.6116 158.492 28.1468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.431 1.59227C149.578 -2.96948 152.361 -7.30104 153.491 -7.00808C154.684 -6.6942 154.202 -1.25359 153.637 1.73875C153.491 2.59669 152.528 7.84899 151.294 7.82806C150.352 7.82806 149.348 4.54276 149.431 1.59227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.033 15.11C201.033 11.6991 198.271 8.93695 194.86 8.93695C192.224 8.93695 189.985 10.5901 189.085 12.9128C188.834 13.6033 188.687 14.3357 188.687 15.11C188.687 18.5208 191.449 21.283 194.86 21.283C197.371 21.283 199.527 19.7763 200.489 17.6419C200.845 16.8468 201.033 16.0097 201.033 15.11Z",
    fill: "#393760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.86 21.2831C197.371 21.2831 199.526 19.7764 200.489 17.642C200.845 16.8678 201.033 16.0099 201.033 15.1101C201.033 11.6992 198.271 8.93706 194.86 8.93706C192.223 8.93706 189.984 10.5902 189.084 12.9129C188.833 13.6034 188.687 14.3358 188.687 15.1101C188.687 18.5 191.449 21.2831 194.86 21.2831ZM194.86 22.3293C190.884 22.3293 187.641 19.0859 187.641 15.1101C187.641 14.2312 187.808 13.3523 188.122 12.5362C189.189 9.75315 191.888 7.89079 194.881 7.89079C198.857 7.89079 202.1 11.1342 202.1 15.1101C202.1 16.1354 201.891 17.1398 201.472 18.0605C200.301 20.6553 197.706 22.3293 194.86 22.3293Z",
    fill: "#46AED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.489 17.6419C198.188 12.0758 192.475 12.2432 189.106 12.8919C188.834 13.5824 188.687 14.3148 188.687 15.089C188.666 18.4999 191.429 21.262 194.839 21.283C197.371 21.283 199.527 19.7763 200.489 17.6419Z",
    fill: "#2F4572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.559 15.11C193.691 15.11 194.61 16.0282 194.61 17.1607C194.61 18.2933 193.691 19.2114 192.559 19.2114C191.426 19.2114 190.508 18.2933 190.508 17.1607C190.508 16.0282 191.426 15.11 192.559 15.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.715 13.8965C200.05 13.6663 199.589 11.5319 198.062 10.6949C196.702 9.96248 194.902 10.5065 194.86 10.9041C194.839 11.1971 195.76 11.2808 197.329 12.2224C198.961 13.2059 199.464 14.0639 199.715 13.8965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.663 15.11C173.663 11.6991 170.901 8.93695 167.49 8.93695C164.853 8.93695 162.614 10.5901 161.714 12.9128C161.463 13.6033 161.317 14.3357 161.317 15.11C161.317 18.5208 164.079 21.283 167.49 21.283C170.001 21.283 172.156 19.7763 173.119 17.6419C173.474 16.8468 173.663 16.0097 173.663 15.11Z",
    fill: "#393760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.489 21.2831C170 21.2831 172.156 19.7764 173.118 17.642C173.474 16.8678 173.662 16.0099 173.662 15.1101C173.662 11.6992 170.9 8.93706 167.489 8.93706C164.853 8.93706 162.614 10.5902 161.714 12.9129C161.463 13.6034 161.316 14.3358 161.316 15.1101C161.316 18.5 164.079 21.2831 167.489 21.2831ZM167.489 22.3293C163.514 22.3293 160.27 19.0859 160.27 15.1101C160.27 14.2312 160.438 13.3523 160.751 12.5362C161.819 9.75315 164.518 7.89079 167.51 7.89079C171.486 7.89079 174.73 11.1342 174.73 15.1101C174.73 16.1354 174.52 17.1398 174.102 18.0605C172.93 20.6553 170.335 22.3293 167.489 22.3293Z",
    fill: "#46AED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.119 17.6419C170.817 12.0758 165.105 12.2432 161.736 12.8919C161.464 13.5824 161.317 14.3148 161.317 15.089C161.296 18.4999 164.058 21.262 167.469 21.283C169.98 21.283 172.136 19.7763 173.119 17.6419Z",
    fill: "#2F4572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.167 15.11C166.3 15.11 167.218 16.0282 167.218 17.1607C167.218 18.2933 166.3 19.2114 165.167 19.2114C164.034 19.2114 163.116 18.2933 163.116 17.1607C163.116 16.0282 164.034 15.11 165.167 15.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.323 13.8965C172.658 13.6663 172.198 11.5319 170.67 10.6949C169.31 9.96248 167.511 10.5065 167.469 10.9041C167.448 11.1971 168.369 11.2808 169.938 12.2224C171.591 13.2059 172.093 14.0639 172.323 13.8965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.807 24.2544C182.87 23.8359 180.087 22.8733 177.22 22.6222C172.554 22.1827 168.285 23.6685 168.348 24.1916C168.369 24.4218 171.319 24.4636 177.22 24.5055C181.949 24.5264 182.765 24.4636 182.807 24.2544Z",
    fill: "#296ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.026 50.314C142.234 50.7087 142.894 52.0083 142.499 53.2167C142.104 54.4251 140.805 55.0847 139.596 54.69C138.388 54.2953 137.728 52.9957 138.123 51.7873C138.518 50.5789 139.817 49.9192 141.026 50.314Z",
    fill: "#296ABD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.26 62.2046C313.066 62.2046 320.205 55.0658 320.205 46.2597C320.205 37.4535 313.066 30.3147 304.26 30.3147C295.454 30.3147 288.315 37.4535 288.315 46.2597C288.315 47.9364 288.667 49.6131 289.15 51.1229C290.271 54.6295 290.832 56.3828 290.75 57.3933C290.729 57.6511 290.718 57.7255 290.667 57.9791C290.469 58.9734 289.751 60.0505 288.315 62.2046H304.26ZM296.655 42.4953C296.655 41.7883 297.228 41.2151 297.935 41.2151H310.737C311.444 41.2151 312.017 41.7883 312.017 42.4953C312.017 43.2023 311.444 43.7754 310.737 43.7754H297.935C297.228 43.7754 296.655 43.2023 296.655 42.4953ZM297.935 48.0426C297.228 48.0426 296.655 48.6157 296.655 49.3227C296.655 50.0297 297.228 50.6029 297.935 50.6029H303.909C304.616 50.6029 305.189 50.0297 305.189 49.3227C305.189 48.6157 304.616 48.0426 303.909 48.0426H297.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0003 78.7497C44.9881 78.7497 35.2503 69.0119 35.2503 56.9997C35.2503 44.9875 44.9881 35.2498 57.0003 35.2498C69.0125 35.2498 78.7502 44.9875 78.7502 56.9997C78.7502 59.2869 78.2692 61.574 77.6107 63.6335C76.0812 68.4167 75.3165 70.8084 75.4291 72.1868C75.4578 72.5384 75.472 72.6399 75.5411 72.9858C75.8118 74.3421 76.7913 75.8113 78.7502 78.7497H57.0003ZM67.3738 51.8649C67.3738 50.9005 66.592 50.1187 65.6276 50.1187H48.1655C47.2011 50.1187 46.4193 50.9005 46.4193 51.8649C46.4193 52.8293 47.2011 53.6111 48.1655 53.6111H65.6276C66.592 53.6111 67.3738 52.8293 67.3738 51.8649ZM65.6276 59.4318C66.592 59.4318 67.3738 60.2136 67.3738 61.178C67.3738 62.1424 66.592 62.9242 65.6276 62.9242H57.4786C56.5142 62.9242 55.7324 62.1424 55.7324 61.178C55.7324 60.2136 56.5142 59.4318 57.4786 59.4318H65.6276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.48 90.3398C185.482 90.3398 180.62 85.4776 180.62 79.4797C180.62 73.4819 185.482 68.6196 191.48 68.6196C197.478 68.6196 202.34 73.4819 202.34 79.4797C202.34 80.6217 202.1 81.7637 201.771 82.7921C201.008 85.1804 200.626 86.3746 200.682 87.0628C200.696 87.2384 200.703 87.2891 200.738 87.4618C200.873 88.139 201.362 88.8726 202.34 90.3398H191.48ZM196.66 76.9158C196.66 76.4343 196.269 76.0439 195.788 76.0439H187.069C186.587 76.0439 186.197 76.4343 186.197 76.9158C186.197 77.3973 186.587 77.7877 187.069 77.7877H195.788C196.269 77.7877 196.66 77.3973 196.66 76.9158ZM195.788 80.6941C196.269 80.6941 196.66 81.0844 196.66 81.566C196.66 82.0475 196.269 82.4379 195.788 82.4379H191.719C191.237 82.4379 190.847 82.0475 190.847 81.566C190.847 81.0844 191.237 80.6941 191.719 80.6941H195.788Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2704_1942",
    x: -13,
    y: -14,
    width: 398,
    height: 166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_1942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2704_1942",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_1942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 105,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2704_1942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 118,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg_2.c8b51a5b7ceca29bf2cce221608662e3.svg";
export { ForwardRef as ReactComponent };